module.exports = __webpack_public_path__ + "Flag-458.96276e2abf226fa71c45c9b8aa957e42.svg";